import React from "react";
import { DepTable } from "components/dep/DepTable";
import { DepHeader } from "components/dep/DepHeader";
import { FullscreenView } from "components/utils/FullscreenView";
import { edstFontDim } from "@poscon/shared-frontend";

export const Dep = () => <FullscreenView view="DEP" HeaderComponent={DepHeader} BodyComponent={DepTable} minWidth={edstFontDim.width * 80} />;
